import type { IndustryPack } from './types'
import { INSURANCE_V1 } from './insurance/v1'
import { FINANCIAL_SERVICES_V1 } from './financial-services/v1'
import { HEALTHCARE_V1 } from './healthcare/v1'
import { SAAS_V1 } from './saas/v1'
import { CONSUMER_V1 } from './consumer/v1'

export const INDUSTRY_PACKS: IndustryPack[] = [
  INSURANCE_V1,
  FINANCIAL_SERVICES_V1,
  HEALTHCARE_V1,
  SAAS_V1,
  CONSUMER_V1,
]

export function getPacksForIndustry(industry: string): IndustryPack[] {
  return INDUSTRY_PACKS.filter(p => p.industry === industry && p.rules.length > 0)
}

export const INDUSTRY_LABELS: Record<string, string> = {
  insurance: 'Insurance',
  financial_services: 'Financial Services',
  healthcare: 'Healthcare',
  saas: 'SaaS',
  consumer: 'Consumer Brands',
}

export const ALL_INDUSTRIES = Object.keys(INDUSTRY_LABELS)
